import z from 'zod';
import { scopedEntity, url } from '../common';
export const overlayPoint = z.object({
    lat: z.number(),
    lng: z.number(),
});
export const overlayPoints = z.object({
    sw: overlayPoint,
    ne: overlayPoint,
    nw: overlayPoint,
    se: overlayPoint,
});
export const overlay = z.object({
    ...scopedEntity.shape,
    imageUrl: url.nullable(),
    level: z.number().default(0),
    points: overlayPoints,
});
